export enum Company {
  BIKA = 'BIKA',
  AMAURI = 'AMAURI',
  PLANETA_ENERGIA = 'PLANETA_ENERGIA',
}
